/**
 * IMPORTS
 */

// typings
import type { ISincronizarCamposVariaveisModeloPayloadDto } from "@/data/dtos/modelos/sincronizar-campos-variaveis-modelo-dto";
import type { ISincronizarCamposVariaveisModeloResponseApi } from "@/data/dtos/response-api/modelos/sincronizar-campos-variaveis-modelo-response-api";
import { AppError } from "@/domain/errors/app-error";
import type { ISincronizarCamposVariaveisModeloRepository } from "@/domain/repositories/modelos/sincronizar-campos-variaveis-modelo-repository-contract";

class SincronizarCamposVariaveisModeloUseCase {
  private readonly repository: ISincronizarCamposVariaveisModeloRepository;

  constructor(repository: ISincronizarCamposVariaveisModeloRepository) {
    this.repository = repository;
  }

  async execute(
    modeloTecnicoId: number,
    payload: ISincronizarCamposVariaveisModeloPayloadDto
  ): Promise<ISincronizarCamposVariaveisModeloResponseApi> {
    if (!modeloTecnicoId || modeloTecnicoId < 1) {
      throw new AppError("ID do modelo técnico inválido!");
    }

    if (!payload || !Array.isArray(payload.campos)) {
      throw new AppError("Lista de campos variáveis inválida!");
    }

    return this.repository.sincronizarCamposPorModelo(modeloTecnicoId, payload);
  }
}

/**
 * EXPORT
 */
export { SincronizarCamposVariaveisModeloUseCase };
